class RateLimitingModal {
    static get $inject() {
        return ['$scope', 'gql', '$interval', '$timeout']
    }

    constructor(scope, gql, $interval, $timeout) {
        this.apply = (fn) => scope.$apply(fn)
        this.gql = gql
        this.interval = $interval
        this.timeout = $timeout
    }

    $onInit() {
        this.seconds = this.resolve.ttl ? parseInt(this.resolve.ttl) : 60
        this.intervalId = this.interval(() => {
            if (this.seconds > 0) {
                this.seconds--
            }
        }, 1000)

        this.timeout(() => this.close(), this.resolve.ttl * 1000)
    }

    $onDestroy() {
        this.interval.cancel(this.intervalId)
    }
}

angular.module("eficienciaFiscalModule")
    .component("rateLimitingModal", {
        controller: RateLimitingModal,
        bindings: {
            close: '&',
            dismiss: '&',
            resolve: '<'
        },
        template: `
        <modal>
            <modal-body>
                    <highlighted>
                        <main>Limite de uso excedido.<br>Aguarde alguns segundos para poder voltar a utilizar.</main>
                        <secondary>
                            Tempo restante: 00:{{$ctrl.seconds.toString().padLeft(2, '0')}}
                        </secondary>
                    </highlighted>
            </modal-body>
        </modal>
        `
    })
